var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"creek-shows-page"},[_c('creek-shows',{attrs:{"weekday":_vm.weekdayNumber,"page-selected":_vm.pageSelected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }